import ActiveItemClose from './ActiveItemClose';
import CommonItemTag from 'components/common-item/CommonItemTag';
import ActiveItemDetailsCard from './ActiveItemDetailsCard';

const ActiveItemDetails = ({ pathname, name, img, type, properties, packType, tag, cost, isMine }) => {

  const getTitle = () => {
    if (pathname) {
      return pathname.includes('packs') ? 'Pack Detail' : 'Card Detail'
    } else {
      return 'Details'
    }
  }

  const formatCost = (value) => {
    if (typeof value === 'number') {
      return value.toFixed(2);
    }

    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue)) {
      return parsedValue.toFixed(2);
    }

    return value;
  }

  return (
    <>
      <section className="card-details__card">
        <h3 className="card-details__title">
          {getTitle()}
          <ActiveItemClose />
        </h3>
        <div className="card-details__bg">
          <ActiveItemDetailsCard name={name} type={type} image={img} props={properties} />
          <p className="card-details__card-text">
          {type === 'prize' ? `$${name}` : name}
          </p>
          {cost && cost !== (0).toFixed(2) ? <p className='cards-list__block-item-rarity'>${formatCost(cost)}</p> : null}
          {packType && <span className={`card-details__card-pack card-details__card-pack--${packType === 'identity' ? 'identity' : 'prediction'}`}>{packType} pack</span>}
          <CommonItemTag tag={tag} isMine={isMine} />
        </div>
      </section>
    </>
  )
}

export default ActiveItemDetails;
